import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import SweetAlert from '../../Shared/Notification';
import OptionModal from './../../Modals/OptionModal';
import { useNavigate, useParams } from 'react-router-dom';
import APIService from '../../../Services/APIService';
import TableHeader from '../../Shared/TableHeader';
import { BackButton } from '../../Shared/BackButton';
import { Form, Button, Row, Col,FormControl,  FormGroup, FormCheck, FormLabel } from 'react-bootstrap';
import SelectDropdown from '../../Shared/SelectDropdown';

const EditBase = () => {
  const navigation = useNavigate();
  const params = useParams();
  const baseInventoryId = params.baseInventoryId;
  const [state, setState] = useState({
    name: '',
    baseAttributes: [],
    selectedBaseInventoryName: '',
    selectedBaseInventoryId: undefined,
    showOptionModal: false,
    attributeOptions: [''],
    attributeInfo: {},
    inventory_type: 'space_based',
    errors: {},
  });

  const optionStyle = {
    fontSize: '12px',
    margin: '0',
    marginTop: '5px',
    textDecoration: 'underline',
    cursor: 'pointer',
  };

  const AttributeTypes = [
    { value: 'FLOAT', label: 'Float' },
    { value: 'STRING', label: 'Text' },
    { value: 'INVENTORY_TYPE', label: 'Inventory list' },
    { value: 'DROPDOWN', label: 'Dropdown' },
    { value: 'EMAIL', label: 'Email' },
    { value: 'MULTISELECT', label: 'Multi Select' },
  ];

  const getAttributeTypeOption = (value) => {
    for (let i = 0, l = AttributeTypes.length; i < l; i += 1) {
      if (AttributeTypes[i].value === value) {
        return AttributeTypes[i];
      }
    }

    return { value };
  };

  const validate = (data) => {
    const errors = {};
    console.log(data);

    if (!data.name.trim()) {
      errors.name = {
        message: 'Please enter a name for base booking',
      };
    }

    for (let i = 0; i < data.baseAttributes.length; i++) {
      let attr = 'attribute' + i;
      let type = 'type' + i;
      if (!data.baseAttributes[i].name) {
        errors[attr] = {
          message: 'This field should not be blank',
        };
      }

      if (!data.baseAttributes[i].type) {
        errors[type] = {
          message: 'Please select the type',
        };
      }

      if (
        (data.baseAttributes[i].type == 'DROPDOWN' ||
          data.baseAttributes[i].type == 'HASHTAG' ||
          data.baseAttributes[i].type == 'MULTISELECT') &&
        (!data.baseAttributes[i].hasOwnProperty('options') ||
          data.baseAttributes[i].options.length == 0 ||
          data.baseAttributes[i].options.indexOf('') > -1)
      ) {
        let opt = 'options' + i;
        errors[opt] = {
          message: 'Please fill the options',
        };
      }
    }

    return errors;
  };

  const getBaseInventoryById = async (baseInventoryId) => {
    let res = await APIService.get(`/v0/ui/dynamic-inventory/base-inventory/${baseInventoryId}/`);
    if (res.status == 200) {
      setState({
        ...state,
        baseAttributes: res.data.base_attributes,
        selectedBaseInventoryId: res.data._id,
        name: res.data.name,
      });
    }
  };

  useEffect(() => {
    if (baseInventoryId) getBaseInventoryById(baseInventoryId);
  }, []);

  const onCancelOptionModal = () => {
    setState({
      ...state,
      showOptionModal: false,
      attributeOptions: [''],
      attributeInfo: {},
    });
  };

  const onSubmitOptionModal = (options, attributeInfo) => {
    setState({
      ...state,
      showOptionModal: false,
      attributeOptions: [''],
      attributeInfo: {},
    });

    let newAttributes = Object.assign({}, attributeInfo.attribute, {
      type: attributeInfo.attributeType,
      options: options,
    });
    handleAttributeChange(newAttributes, attributeInfo.attrIndex);
  };

  const onOpenOptionModal = (options, attributeType, attribute, attrIndex) => {
    setState({
      ...state,
      showOptionModal: true,
      attributeOptions: options,
      attributeInfo: {
        attributeType,
        attribute,
        attrIndex,
      },
    });
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    const errors = validate(state);

    if (Object.keys(errors).length) {
      setState({
        errors,
      });
    } else {
      let req_data = {
        name: state.name,
        base_attributes: state.baseAttributes,
        inventory_type: 'space_based',
      };
      let res = await APIService.put(
        `/v0/ui/dynamic-inventory/base-inventory/${baseInventoryId}/`,
        req_data
      );
      if (res.status == 200) {
        SweetAlert('Base Inventory updated successfully', 'success');
        navigation(`/r/inventory/base/list`);
      }
    }
  };
  const onAddAttribute = () => {
    const newAttributes = state.baseAttributes.slice();

    newAttributes.push({
      name: '',
      type: '',
      is_required: false,
    });

    setState({
      ...state,
      baseAttributes: newAttributes,
    });
  };

  const handleAttributeChange = (attribute, index) => {
    const attributes = state.baseAttributes.slice();
    attributes.splice(index, 1, attribute);
    setState({
      ...state,
      baseAttributes: attributes,
    });
  };

  const handleInputChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const renderAttributeRow = (attribute, attrIndex) => {
    const { errors } = state;
    const onNameChange = (event) => {
      const newAttribute = Object.assign({}, attribute);
      newAttribute.name = event.target.value;
      handleAttributeChange(newAttribute, attrIndex);
    };

    const onTypeChange = (item) => {
      if (item.value === 'DROPDOWN' || item.value === 'MULTISELECT') {
        setState({
          ...state,
          showOptionModal: true,
          columnOptions: [''],
          attributeInfo: {
            attributeType: item.value,
            attribute,
            attrIndex,
          },
        });
      }
      const newAttribute = Object.assign({}, attribute);

      newAttribute.type = item.value;

      handleAttributeChange(newAttribute, attrIndex);
    };

    const onRequiredChange = (event) => {
      const newAttribute = Object.assign({}, attribute);
      newAttribute.is_required = !!event.target.checked;
      handleAttributeChange(newAttribute, attrIndex);
    };

    return (
      // <div className="createform__form__row" key={`row-${attrIndex}`}>
      //   <div className="createform__form__inline">
      //     <div className="form-control form-control--column">
      //       <input
      //         type="text"
      //         placeholder="Name"
      //         value={attribute.name}
      //         onChange={onNameChange}
      //         className={{ error: errors['attribute' + attrIndex] }}
      //       />
      //       {errors && errors['attribute' + attrIndex] ? (
      //         <p className="message message--error">{errors['attribute' + attrIndex].message}</p>
      //       ) : null}
      //     </div>
      //     <div className="form-control form-control--column">
      //       <Select
      //         options={AttributeTypes}
      //         classNamePrefix="form-select"
      //         value={getAttributeTypeOption(attribute.type)}
      //         onChange={onTypeChange}
      //         className={{ error: errors['attribute' + attrIndex] }}
      //       />
      //       {attribute.type === 'DROPDOWN' || attribute.type === 'MULTISELECT' ? (
      //         <p
      //           className="show-option"
      //           style={optionStyle}
      //           onClick={() =>
      //             onOpenOptionModal(
      //               attribute.options,
      //               attribute.type,
      //               attribute,
      //               attribute.attrIndex
      //             )
      //           }
      //         >
      //           Show Options
      //         </p>
      //       ) : (
      //         ''
      //       )}
      //       {errors && errors['options' + attrIndex] ? (
      //         <p className="message message--error">{errors['options' + attrIndex].message}</p>
      //       ) : null}
      //       {errors && errors['type' + attrIndex] ? (
      //         <p className="message message--error">{errors['type' + attrIndex].message}</p>
      //       ) : null}
      //     </div>
      //     <div className="form-control required-field">
      //       <div>Is it required?</div>
      //       <input
      //         type="checkbox"
      //         className="input-checkbox"
      //         value={attribute.is_required}
      //         checked={attribute.is_required}
      //         onChange={onRequiredChange}
      //       />
      //     </div>
      //   </div>
      // </div>

      <Row key={`row-${attrIndex}`}>
        <Col>
          <FormGroup className="my-2">
            <Form.Control
              type="text"
              placeholder="Name"
              value={attribute.name}
              onChange={onNameChange}
              className={{ error: errors['attribute' + attrIndex] }}
            />
            {errors && errors['attribute' + attrIndex] ? (
              <p className="message message--error">{errors['attribute' + attrIndex].message}</p>
            ) : null}
          </FormGroup>
          <Row>
  <Col>
    <SelectDropdown
      optionsData={AttributeTypes}
      isClearable={false}
      classNamePrefix="form-select"
      selectedValue={getAttributeTypeOption(attribute.type)}
      onChange={onTypeChange}
      className={{ error: errors['attribute' + attrIndex] }}
    />
    {attribute.type === 'DROPDOWN' || attribute.type === 'MULTISELECT' ? (
      <p
        className="show-option"
        style={optionStyle}
        onClick={() =>
          onOpenOptionModal(
            attribute.options,
            attribute.type,
            attribute,
            attribute.attrIndex
          )
        }
      >
        Show Options
      </p>
    ) : (
      ''
    )}
    {errors && errors['options' + attrIndex] ? (
      <p className="message message--error">{errors['options' + attrIndex].message}</p>
    ) : null}
    {errors && errors['type' + attrIndex] ? (
      <p className="message message--error">{errors['type' + attrIndex].message}</p>
    ) : null}
  </Col>
  <Col>
    <FormGroup className="inline my-1.5 border border-primary p-2">
      <Form.Check
        type="checkbox"
        name="option"
        label={'Is it required ?'}
        value={attribute.is_required}
        checked={attribute.is_required}
        onChange={onRequiredChange}
      />
    </FormGroup>
  </Col>
</Row>

        </Col>
      </Row>
    );
  };

  const { errors } = state;
  const backButton = () => {
    return <BackButton onClick={() => navigation(`/r/inventory/base/list`)} />;
  };

  return (
    <>
      <TableHeader headerValue={'Edit - Inventory Standard Template'} isBackButton={backButton} />
      {/* <div className="createform">
        <div className="createform__form">
          <form onSubmit={onSubmit}>
            <div className="createform__form__inline">
              <div className="form-control">
                <label>*Enter Name For Base Inventory</label>
                <input
                  type="text"
                  name="name"
                  value={state.name}
                  onChange={handleInputChange}
                  className={{ error: errors.name }}
                />
                {errors && errors.name ? (
                  <p className="message message--error">{errors.name.message}</p>
                ) : null}
              </div>
            </div>
            <div className="createform__form__header">Attributes</div>
            <div>{state.baseAttributes.map(renderAttributeRow)}</div>
            <div className="createform__form__inline">
              <div className="createform__form__action">
                <button type="button" className="btn btn--danger" onClick={onAddAttribute}>
                  Add Attribute
                </button>
              </div>
              <div className="createform__form__action">
                <button type="submit" className="btn btn--danger">
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
        <OptionModal
          key={state.attributeInfo.attrIndex}
          showOptionModal={state.showOptionModal}
          onCancel={onCancelOptionModal}
          onSubmit={onSubmitOptionModal}
          options={state.attributeOptions}
          columnInfo={state.attributeInfo}
        />
      </div> */}
      <div>
        <Row>
          <Form onSubmit={onSubmit}>
            <Col>
              <FormGroup className="form-control">
                <Form.Label>Enter Name For Base Inventory  <span className="required-field">*</span></Form.Label>
                <FormControl
                  type="text"
                  name="name"
                  value={state.name}
                  onChange={handleInputChange}
                  className={{ error: errors.name }}
                />
                {errors && errors.name ? (
                  <p className="message message--error">{errors.name.message}</p>
                ) : null}
              </FormGroup>
            </Col>
            <Form.Label className="form-label">Attributes</Form.Label>
            <div>{state.baseAttributes.map(renderAttributeRow)}</div>
          <Col style={{paddingTop:'10px'}}>
            <Button variant="primary" onClick={onAddAttribute} style={{marginRight: '10px' }}>
                Add Attribute
              </Button>
              <Button type="submit" variant="primary" >
                Submit
              </Button>
          </Col>
          </Form>
        </Row>
        <OptionModal
          key={state.attributeInfo.attrIndex}
          showOptionModal={state.showOptionModal}
          onCancel={onCancelOptionModal}
          onSubmit={onSubmitOptionModal}
          options={state.attributeOptions}
          columnInfo={state.attributeInfo}
        />
      </div>
    </>
  );
};

export default EditBase;
